export interface IAchievement {
    name: string;
    description: string;
}

export enum AchievementID {
    PLACEHOLDER,
    FIRST_DIAGNOSIS,
    FIRST_MISDIAGNOSIS,
    SEEING_STARS, // solve a case with max stars
    ONE_STAR_FAILURE, // failing a one star case
    DOCTOR_BUTT, // three gastroscopies at once
    QUICK_ON_THE_DRAW, // solve a case within 1 minute
    // RAPID_FIRE, // solve 5 cases within 5 minutes
    NUM_OF_ACHIEVEMENTS,
}

export const Achievements: Record<AchievementID, IAchievement> = {
    // @ts-ignore
    [AchievementID.PLACEHOLDER]: {
        // name: "Placeholder",
        // description: "A placeholder achievement.",
        // iconKey: "",
    },
    [AchievementID.FIRST_DIAGNOSIS]: {
        name: "The First of Many",
        description: "You made your first diagnosis. Congratulations!",
    },
    [AchievementID.FIRST_MISDIAGNOSIS]: {
        name: "Misdiagnosis",
        description: "You made your first misdiagnosis. Hopefully not the first of many!",
    },
    [AchievementID.SEEING_STARS]: {
        name: "Seein' Stars",
        description: "You solved a very difficult case! Good diagnosing!",
    },
    [AchievementID.ONE_STAR_FAILURE]: {
        name: "Embarrassing",
        description: "You misdiagnosed a very easy case... how embarrassing.",
    },
    [AchievementID.DOCTOR_BUTT]: {
        name: "Doctor Butt",
        description: "Did you really need to run three proctology exams at once?",
    },
    [AchievementID.QUICK_ON_THE_DRAW]: {
        name: "Fastest Diagnosis in the West",
        description: "Only one minute to diagnose? Darn, you're really good!",
    },

    // @ts-ignore
    [AchievementID.NUM_OF_ACHIEVEMENTS]: {},
};